import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class SnackBarService {

  listener = new Subject<any>();
  display: boolean;
  type: string;
  message: string;

  // tslint:disable-next-line:no-empty
  constructor() { }

  public getMessage() {
    return new Observable(
      (observable) => {
        observable.next(this.message);
      }
    );
  }

  public setMessage(message) {
    return new Observable(
      (observable) => {
        this.message = message;
      }
    );
  }

  public listen() {
    return this.listener.asObservable();
  }

  public open(message, type) {
    this.message = message;
    this.type = type;
    this.listener.next( { message: this.message, type: this.type });
  }

}
